export enum AnimationMode {
    slide,
    fade
}